import React, { useState } from 'react';
import { Modal, Button, Alert } from 'react-bootstrap';
import { DELETE_ROLE } from 'services/api/role';
import { DeleteRoleModalProps } from '../types/types';
import { toast } from 'react-hot-toast';

const DeleteRoleModal: React.FC<DeleteRoleModalProps> = ({
  show,
  onHide,
  role,
  onSuccess
}) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const handleDelete = async () => {
    const roleId = (role as any)?.id || role?._id;
    if (!roleId) return;

    setLoading(true);
    setError(null);
    try {
      await DELETE_ROLE(roleId);
      toast.success('Role deleted successfully');
      onSuccess();
      onHide();
    } catch (err) {
      setError((err as Error).message || 'Failed to delete role');
      toast.error('Failed to delete role');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton={!loading}>
        <Modal.Title>Confirm Deletion</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && (
          <Alert variant="danger" onClose={() => setError(null)} dismissible>
            {error}
          </Alert>
        )}
        <p>
          Are you sure you want to delete the role{' '}
          <strong>{role?.name || 'this role'}</strong>?
        </p>
        <p className="text-muted">
          This action cannot be undone and may affect users assigned to this
          role.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={loading}>
          Cancel
        </Button>
        <Button variant="danger" onClick={handleDelete} disabled={loading}>
          {loading ? 'Deleting...' : 'Delete'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteRoleModal;
